// Shabz's real photos (uploaded). Faces/likeness untouched; only framing/cropping applied.
export const IMAGES = {
  hero: "/shabz/p3.jpeg", // office, white blazer, skyline
  work: "/shabz/p0.jpeg", // portrait (story caption cropped via object-position)
  lifestyle1: "/shabz/p1.jpeg", // night glam
  lifestyle2: "/shabz/p2.jpeg", // daytime selfie
  finalCta: "/shabz/p1.jpeg",
  logo: "/shabz/logo.jpg",
  island: "/shabz/island.jpeg",
  party: "/shabz/party.jpeg",
  office: "/shabz/office.jpeg",
  yacht: "/shabz/yacht.jpeg",
  penthouse: "/shabz/penthouse.jpeg",
  supercar: "/shabz/supercar.jpeg",
  wealth: "/shabz/wealth.jpeg",
  beach: "/shabz/beach.jpeg",
  bitcoin: "/shabz/bitcoin.jpeg",
};
